"use client"

import { useState, FormEvent } from "react"

export function Newsletter() {
  const [email, setEmail] = useState("")
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle")
  const [message, setMessage] = useState("")

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setStatus("loading")
    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      })
      const data = await res.json()
      if (!res.ok) {
        setStatus("error")
        setMessage(data.error || "Something went wrong")
      } else {
        setStatus("success")
        setMessage(data.message)
        setEmail("")
      }
    } catch {
      setStatus("error")
      setMessage("Failed to subscribe. Please try again.")
    }
  }

  return (
    <section className="py-20 bg-[#F9F9F9]">
      <div className="container">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-light mb-6 tracking-[0.15em] uppercase text-[#2B2C2D]">
            Subscribe to our Newsletter
          </h2>
          <p className="text-gray-600 mb-8 text-sm md:text-base">
            Be the first to know about new collections and exclusive offers.
          </p>
          
          {status === "success" ? (
            <p className="text-green-600 text-sm">{message}</p>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col md:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-6 py-4 border border-gray-300 focus:outline-none focus:border-primary transition-colors"
                required
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="px-8 py-4 bg-primary text-white uppercase tracking-widest text-sm font-medium hover:bg-accent transition-colors disabled:opacity-50"
              >
                {status === "loading" ? "..." : "Subscribe"}
              </button>
            </form>
          )}
          {status === "error" && (
            <p className="text-red-500 text-sm mt-2">{message}</p>
          )}
        </div>
      </div>
    </section>
  )
}
